import React, { Component } from 'react'
import '../../css/BisharatMain.css';
import ActivityService from '../../services/ActivityService';
import Calendar from 'react-calendar';
import AuthService from '../../services/AuthService';
import Moment from 'moment';
import { MemberLinkBtnBlue  } from '../../styles/Elements';
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import Login from '../../pages/Login';

export default class ActivityCreate extends Component {
  constructor() {
    super()
    this.state = {
      "activityName": '',
      "activityLink": '',
      "createdBy": '',
      "dateOfActivity": new Date(),
      haveRoleOfAdminOrMod:false
    };
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidMount() {
    this.checkSession();
}

checkSession = () => {
  const loggedInUser = AuthService.getCurrentUser();
  const whatRole = AuthService.getUserRole();
  if (loggedInUser) {
      if (whatRole === ('MODERATOR') || whatRole === ('ADMIN')) {
          this.setState({ haveRoleOfAdminOrMod: true });
      }
  }      
  }

  onChangeDate = dateOfActivity => this.setState({dateOfActivity});
  

  onChange(event) {
    this.setState({ [event.target.name]: event.target.value })
  }


  onSubmit(event) {
    event.preventDefault()

    this.setState({
      message: "",
      loading: true
    });

    this.form.validateAll();

    if (this.checkBtn.context._errors.length === 0) {
    const newActivity = {
      activityName: this.state.activityName,
      activityLink: this.state.activityLink,
      dateOfActivity: Moment(this.state.dateOfActivity).format('DD-MM-YYYY'),
      createdBy: AuthService.getCurrentUser().id,
      successful: false,
      message: "",
      errors: {}
    };
    this.createActivity(newActivity);
  } else {
    this.setState({
      loading: false
    });
  }
}

  createActivity(newActivity) {
    ActivityService.createActivity(newActivity)
      .then((response) => {
        this.setState({
          message: response.data.message,
          successful: true
        });
        window.open('/family-activities', "_self");
      },
        error => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();

          this.setState({
            successful: false,
            message: resMessage
          });
        }
      );
  }




  render() {

    const required = value => {
      if (!value) {
        return (
          <div className="alertDanger" >
               <p className="alertDanger">  
         اجباري         
          </p> 
          </div>
        );
      }
    };

    return (
<div>
          {!this.state.haveRoleOfAdminOrMod ? 
           <div>
           <Login></Login>
       </div> :

      <div className="mainCreate">
        <div className="top-container-forms activitycreate">

          <div className="create-form">

            <h1>اضافة فعاليّة جديد</h1>
            <Form onSubmit={this.onSubmit}
               ref={c => {
                this.form = c;
              }}>
              <div className="form-group-create">
                <h5> عنوان الفعاليّة </h5>
                <Input type="text"
                className="form-control-form-cont"
                  name="activityName" placeholder="فعاليّة"
                  value={this.state.activityName}
                  onChange={this.onChange}
                  validations={[required]}
                />

              </div>

              <div className="form-group-create">
                <h5> رابط الفعاليّة </h5>
                <input type="text" className="form-control-form-cont"
                  name="activityLink" placeholder="الرابط"
                  value={this.state.activityLink}
                  onChange={this.onChange}
                />

              </div>

              <div className="form-group-create">
              <h5> تاريخ الفعاليّة </h5>
                <Calendar className="react-calendar"

                  onChange={this.onChangeDate}
                  value={this.state.dateOfActivity}
                />
            
  {/* <h5> {this.state.dateOfActivity.toString()} </h5> */}
              </div>
            
              {/* <input type="submit" value="ارسال" className="btn btn-primary btn-block mt-4" /> */}
              <div className="form-group-create">
              <button
                className="btn"
                disabled={this.state.loading}
              >
                {this.state.loading && (
                  <span className="spinner-border spinner-border-sm"></span>
                )}
                ارسال
              </button>

              {this.state.message && (
                <div className="form-group-create">
                  <div
                    className={
                      this.state.successful
                        ? "alertSuccess"
                        : "alertDanger"
                    }
                    role="alert"
                  >
                    {this.state.message}
                  </div>
                </div>
              )}
  <CheckButton
              style={{ display: "none" }}
              ref={c => {
                this.checkBtn = c;
              }}
            />
            </div>
           
            </Form> 
         <MemberLinkBtnBlue to='/adminboard/'> Back to Admin Board </MemberLinkBtnBlue>
</div>

          </div>

        </div>
      }</div>

    )
  }
}
